export default __webpack_public_path__ + "media/images/mailer/icon_warning-af2b38fe580f274ca4c80479bd12141e.png";